import { render, staticRenderFns } from "./NeoparentMenu.vue?vue&type=template&id=74dba090&scoped=true"
import script from "./NeoparentMenu.vue?vue&type=script&lang=js"
export * from "./NeoparentMenu.vue?vue&type=script&lang=js"
import style0 from "./NeoparentMenu.vue?vue&type=style&index=0&id=74dba090&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dba090",
  null
  
)

export default component.exports